// @flow
/*
 *  Copyright 2018 Adobe Systems Incorporated. All rights reserved.
 *  This file is licensed to you under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License. You may obtain a copy
 *  of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software distributed under
 *  the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 *  OF ANY KIND, either express or implied. See the License for the specific language
 *  governing permissions and limitations under the License.
 *
 */

// import getConfigApps from '../config';

export default class GMOData {
	productDownload(productName: string, isThorInstalled: boolean) {
		const digitalData = window.digitalData;
		if (typeof digitalData === 'undefined') {
			return;
		}
		// event for Product Download
		digitalData._set(
			'digitalData.primaryEvent.eventInfo.eventAction',
			'productDownload'
		);

		// This will contain the product name which is being downloaded
		// Refer the ProductNamesinAA document for list of Product names tracking in AA
		digitalData._set(
			'digitalData.primaryProduct.productInfo.productID',
			productName
		);

		// Flag to identify whether Thor is installed in User's machine or not
		// type: boolean
		// true - Thor Installed or false - Thor is not installed
		digitalData._set(
			'digitalData.adobe.creativecloud.isThorInstalled',
			isThorInstalled
		);

		// Call this below _satellite.track event call once the above Product Download event information is set in digitalData
		window._satellite.track('event', {
			digitalData: digitalData._snapshot()
		});

		digitalData._delete('digitalData.primaryEvent.eventInfo.eventAction');
		digitalData._delete('digitalData.primaryProduct.productInfo.productID');
		digitalData._delete('digitalData.adobe.creativecloud.isThorInstalled');
	}
};